module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "registration-success g-py-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0"
  }, [_c('div', {
    staticClass: "success-div"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n              You have successfully submitted your registration form for the Changing Life through Lenses® program!\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v("\n                to download a copy of the contract for your records.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n              An email has been sent to the email address you provided with a link to activate your account.\n            ")])])])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d0c1ea16", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0c1ea16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/RegistrationSuccess.vue
// module id = 555
// module chunks = 3